export function registerButtonDirectives(Alpine) {
  // Alpine directive for masked hover effect on buttons
  Alpine.directive("maskedhover", (el) => {
    if (!window.gsap) return;
    const textCurrent = el.querySelector(
      ".masked-element:not(.masked-mask):not(.is-horizontal)",
    );
    const textMask = el.querySelector(".masked-element.masked-mask");
    const iconMask = el.querySelector(".masked-element.is-horizontal");
    if (textCurrent) gsap.set(textCurrent, { y: 0, opacity: 1 });
    if (textMask) gsap.set(textMask, { y: 20, opacity: 0 });
    if (iconMask) gsap.set(iconMask, { x: 0 });
    el.addEventListener("mouseenter", () => {
      if (textCurrent) {
        gsap.to(textCurrent, {
          y: -20,
          opacity: 0,
          duration: 1,
          ease: "power4.out",
          overwrite: "auto",
        });
      }
      if (textMask) {
        gsap.to(textMask, {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: "power4.out",
          overwrite: "auto",
        });
      }
      if (iconMask) {
        gsap.to(iconMask, {
          x: 6,
          duration: 0.5,
          ease: "power2.out",
          overwrite: "auto",
        });
      }
    });
    el.addEventListener("mouseleave", () => {
      if (textCurrent) {
        gsap.to(textCurrent, {
          y: 0,
          opacity: 1,
          duration: 1.1,
          ease: "power4.out",
          overwrite: "auto",
        });
      }
      if (textMask) {
        gsap.to(textMask, {
          y: 20,
          opacity: 0,
          duration: 1.1,
          ease: "power4.out",
          overwrite: "auto",
        });
      }
      if (iconMask) {
        gsap.to(iconMask, {
          x: 0,
          duration: 0.5,
          ease: "power2.out",
          overwrite: "auto",
        });
      }
    });
  });
  Alpine.directive("iconhover", (el) => {
    if (!window.gsap) return;

    // Tìm icon bên trong element
    const icon = el.querySelector(".is-horizontal") || el.querySelector("svg");

    if (icon) {
      // Đặt trạng thái ban đầu
      gsap.set(icon, { x: 0 });

      el.addEventListener("mouseenter", () => {
        gsap.to(icon, {
          x: 3, // Di chuyển sang phải 3px
          duration: 0.5,
          ease: "power2.out",
          overwrite: "auto",
        });
      });

      el.addEventListener("mouseleave", () => {
        gsap.to(icon, {
          x: 0, // Quay về vị trí cũ
          duration: 0.5,
          ease: "power2.out",
          overwrite: "auto",
        });
      });
    }
  });
}
